import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

// Helper to get valid admin access token, refresh if needed
async function getAdminAccessToken() {
  let accessToken = localStorage.getItem('gogig_admin_access');
  const refreshToken = localStorage.getItem('gogig_admin_refresh');
  if (accessToken) {
    try {
      const res = await fetch(`${API_URL}/api/admin/stats`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (res.status !== 401) return accessToken;
    } catch {}
  }
  if (refreshToken) {
    try {
      const res = await fetch(`${API_URL}/api/admin/refresh-token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken })
      });
      const data = await res.json();
      if (data.success && data.accessToken) {
        localStorage.setItem('gogig_admin_access', data.accessToken);
        return data.accessToken;
      }
    } catch {}
  }
  localStorage.removeItem('gogig_admin_access');
  localStorage.removeItem('gogig_admin_refresh');
  window.location.href = '/admin';
  return null;
}

async function adminFetch(url, options = {}) {
  const token = await getAdminAccessToken();
  if (!token) throw new Error('Not authenticated');
  const headers = { ...(options.headers || {}), Authorization: `Bearer ${token}` };
  return fetch(url, { ...options, headers });
}

function AdminAssessmentDueReport({ getToken, fetch: fetchProp }) {
  const fetchFn = fetchProp || adminFetch;
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1; // getMonth() returns 0-11
  
  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(currentMonth);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDownload = async () => {
    setError('');
    if (!year || !month) return setError('Select year and month');
    setLoading(true);
    try {
      const res = await fetchFn(`${API_URL}/api/documents/assessment-due-report?year=${year}&month=${month}&format=csv`);
      if (!res.ok) throw new Error('Download failed');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `assessment_due_report_${year}_${month.toString().padStart(2, '0')}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      setError('Download failed');
    }
    setLoading(false);
  };

  // Generate year options (current year and 5 years back)
  const yearOptions = [];
  for (let y = currentYear; y >= currentYear - 5; y--) {
    yearOptions.push(y);
  }

  // Generate month options
  const monthOptions = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' }
  ];

  return (
    <div className="gogig-card" style={{ maxWidth: 400, margin: '0 auto', padding: 24 }}>
      <h2 style={{ marginBottom: 16 }}>Assessment Due Report</h2>
      <div style={{ marginBottom: 10 }}>
        <label>Year: </label>
        <select 
          value={year} 
          onChange={e => setYear(parseInt(e.target.value))} 
          style={{ width: 120, marginRight: 10 }}
        >
          {yearOptions.map(y => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>
      <div style={{ marginBottom: 10 }}>
        <label>Month: </label>
        <select 
          value={month} 
          onChange={e => setMonth(parseInt(e.target.value))} 
          style={{ width: 160 }}
        >
          {monthOptions.map(m => (
            <option key={m.value} value={m.value}>{m.label}</option>
          ))}
        </select>
      </div>
      {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
      <button className="gogig-card-btn" onClick={handleDownload} disabled={loading}>
        {loading ? 'Downloading...' : 'Download CSV'}
      </button>
    </div>
  );
}

export default AdminAssessmentDueReport; 